function e(e){return e&&e.__esModule&&Object.prototype.hasOwnProperty.call(e,"default")?e.default:e}export{e as getDefaultExportFromCjs};
//# sourceMappingURL=_commonjsHelpers.js.map
